// Progress rail constants
export const PROGRESS_FIXED_WIDTH = 233;
export const PROGRESS_RAIL_HEIGHT = 4;
export const PROGRESS_DOT_SIZE = 17;
